import OffSelectAttribute from './OffSelectAttribute'

export default OffSelectAttribute
